module.exports = __webpack_public_path__ + "img/0Q3B3199_L_Foamcore_MockedUp.e2ae15ee.jpg";